import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AccommSupportReviewComponent } from "../app/internal/accmgr/accomms-support-review/accomms-support-review.component";
import { AccommodationCategoryComponent } from "../app/internal/accmgr/ba/accommodation-category/accommodationcat.component";
import { AccommodationComponent } from "../app/internal/accmgr/ba/Accommodation/accommodation.component";
import { AnalystsComponent } from "../app/internal/accmgr/ba/analysts/analysts.component";
import { DisabilityCategoryComponent } from "../app/internal/accmgr/ba/disability-category/disabilitycat.component";
import { DisabilityComponent } from "../app/internal/accmgr/ba/Disability/disability.component";
import { DocTypeComponent } from "../app/internal/accmgr/ba/document-type/documenttype.component";
import { DynamicContentComponent } from "../app/internal/accmgr/ba/dynamic-content/dynamiccontent.component";
import { BAComponent } from "../app/internal/accmgr/ba/Home/ba.component";
import { InternalPlanComponent } from "../app/internal/accmgr/ba/internal-plan/internalplan.component";
import { InternalTestComponent } from "../app/internal/accmgr/ba/internal-test/internaltest.component";
import { ParagraphsComponent } from "../app/internal/accmgr/ba/Paragraphs/paragraphs.component";
import { SpecialAuthCodesComponent } from "../app/internal/accmgr/ba/special-authorization-codes/specialauthcodes.component";
import { TestAdministrationsComponent } from "../app/internal/accmgr/ba/test-administrations/testadministrations.component";
import { ConsultantDecisionComponent } from "../app/internal/accmgr/consultant-decision/consultant-decision.component";
import { ConsultantReviewSubmitComponent } from "../app/internal/accmgr/consultant-review-submit/consultant-reviewsubmit.component";
import { ExamineeRequestDetailsComponent } from "../app/internal/accmgr/examinee-request-details/examinee-request-details.component";
import { LandingComponent } from "../app/internal/accmgr/landing/landing.component";
import { AccSupportDocumentationComponent } from "../app/internal/accomsupport/accsupportdocumentation/accsupportdocumentation.component";
import { AccSupportLandingComponent } from "../app/internal/accomsupport/accsupportlanding/accsupportlanding.component";
import { AccSupportPlanComponent } from "../app/internal/accomsupport/accsupportplan/accsupportplan.component";
import { AccSupportReasonsComponent } from "../app/internal/accomsupport/accsupportreasons/accsupportreasons.component";
import { AssignTestAdminComponent } from "../app/internal/accomsupport/assign-test-administration/assign-test-administration.component";
import { ExamineeInternalComponent } from "../app/internal/accomsupport/edit-examinee/examinee.component";
import { ExamineeAccRequestDetailsComponent } from "../app/internal/accomsupport/examinee-request-details/examinee-request-details.component";
import { UnAssignTestAdminComponent } from "../app/internal/accomsupport/unassign-test-administration/unassign-test-administration.component";
import { AssignTestAdminCommonComponent } from "../app/internal/common/components/assign-test-administration/assign-test-administration.common.component";
import { ExamineeEditInternalComponent } from "../app/internal/common/components/edit-examinee/examinee.edit.component";
import { TransferStudentCommonComponent } from "../app/internal/common/components/transferstudent/transferstudent.component";
import { UnAssignTestAdminCommonComponent } from "../app/internal/common/components/unassign-test-administration/unassign-test-administration.component";
import { SearchComponent } from "../app/internal/common/search/search.component";
import { ConsultantLandingComponent } from "../app/internal/internalconsultants/consultantlanding/consultantlanding.component";
import { PaperRequestLandingComponent } from "./../app/internal/accomsupport/paperrequestlanding/paperrequestlanding.component";
import { PaperStepperComponent } from "./../app/internal/accomsupport/process-paper-request/stepper/paper-stepper.component";
import { ContactusComponent } from "./contactus/contactus.component";
import { ListComponent } from "./examinees/list/list.component";
import { FaqComponent } from "./faq/faq.component";
import { OrganizationComponent } from "./organization/organization/organization.component";
import { RequestHistoryComponent } from "./request-history/request-history.component";
import { AccommodationsComponent } from "./request/accommodations/accommodations.component";
import { ConfirmationComponent } from "./request/confirmation/confirmation.component";
import { DocumentationComponent } from "./request/documentation/documentation.component";
import { PlanComponent } from "./request/plan/plan.component";
import { ReasonComponent } from "./request/reason/reason.component";
import { RequestSubmitComponent } from "./request/requestsubmit/requestsubmit.component";
import { StepperComponent } from "./request/stepper/stepper.component";
import { TestinginformationComponent } from "./request/testinginformation/testinginformation.component";
import { AuthExternalB2BGuard } from "./services/auth-external-b2b.guard";
import { AuthInternalAccmgrGuard } from "./services/auth-internal-accmgr-guard";
import { AuthInternalAccommodationSupportGuard } from "./services/auth-internal-accommodation-support-guard";
import { AuthInternalConsultantGuard } from "./services/auth-internal-consultant-guard";
import { AuthInternalGuard } from "./services/auth-internal-guard";
import { SystemErrorComponent } from "./system-error/system-error.component";

export const appRoutes: Routes = [
  {
    path: "request",
    component: StepperComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "test",
    component: TestinginformationComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "accommodations",
    component: AccommodationsComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "contactus",
    component: ContactusComponent
  },
  {
    path: "exreqdetails",
    component: ExamineeRequestDetailsComponent,
    canActivate: [AuthInternalGuard]
  },
  {
    path: "exAccreqdetails",
    component: ExamineeAccRequestDetailsComponent,
    canActivate: [AuthInternalGuard]
  },
  {
    path: "editExaminee",
    component: ExamineeInternalComponent,
    canActivate: [AuthInternalAccommodationSupportGuard]
  },
  {
    path: "faq",
    component: FaqComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "examinees",
    component: ListComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "plan",
    component: PlanComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "reason",
    component: ReasonComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "documentation",
    component: DocumentationComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "reqHistory",
    component: RequestHistoryComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "organization",
    component: OrganizationComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "sysError",
    component: SystemErrorComponent
  },
  {
    path: "requestSubmit",
    component: RequestSubmitComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "confirmation",
    component: ConfirmationComponent,
    canActivate: [AuthExternalB2BGuard]
  },
  {
    path: "accmgr",
    component: LandingComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },

  {
    path: "businessAdministration",
    component: BAComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "accommsSupport",
    component: AccommSupportReviewComponent,
    canActivate: [AuthInternalGuard]
  },
  {
    path: "accSupportReasons",
    component: AccSupportReasonsComponent,
    canActivate: [AuthInternalGuard]
  },
  {
    path: "accSupportPlan",
    component: AccSupportPlanComponent,
    canActivate: [AuthInternalGuard]
  },
  {
    path: "internalPlan",
    component: InternalPlanComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "doctype",
    component: DocTypeComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "analysts",
    component: AnalystsComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "spclAuthCodes",
    component: SpecialAuthCodesComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "paragraphs",
    component: ParagraphsComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "internalTest",
    component: InternalTestComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "testAdministrations",
    component: TestAdministrationsComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "disabilityCat",
    component: DisabilityCategoryComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "consultantReviewDecision",
    component: ConsultantReviewSubmitComponent,
    canActivate: [AuthInternalGuard]
  },
  {
    path: "consultantDecision",
    component: ConsultantDecisionComponent,
    canActivate: [AuthInternalGuard]
  },
  {
    path: "disability",
    component: DisabilityComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "accommCat",
    component: AccommodationCategoryComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "accommodation",
    component: AccommodationComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "dynamicContent",
    component: DynamicContentComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "intconslanding",
    component: ConsultantLandingComponent,
    canActivate: [AuthInternalConsultantGuard]
  },
  {
    path: "search",
    component: SearchComponent,
    canActivate: [AuthInternalConsultantGuard]
  },
  {
    path: "intsuplanding",
    component: AccSupportLandingComponent,
    canActivate: [AuthInternalAccommodationSupportGuard]
  },
  {
    path: "intpaperreqlanding",
    component: PaperRequestLandingComponent,
    canActivate: [AuthInternalAccommodationSupportGuard]
  },
  {
    path: "intassigntestadmin",
    component: AssignTestAdminComponent,
    canActivate: [AuthInternalAccommodationSupportGuard]
  },
  {
    path: "intunassigntestadmin",
    component: UnAssignTestAdminComponent,
    canActivate: [AuthInternalAccommodationSupportGuard]
  },
  {
    path: "intcomassigntestadmin",
    component: AssignTestAdminCommonComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "inttransferstudent",
    component: TransferStudentCommonComponent,
    canActivate: [AuthInternalGuard]
  },
  {
    path: "intcomunassigntestadmin",
    component: UnAssignTestAdminCommonComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "inteditExaminee",
    component: ExamineeEditInternalComponent,
    canActivate: [AuthInternalAccmgrGuard]
  },
  {
    path: "paper-request",
    component: PaperStepperComponent,
    canActivate: [AuthInternalAccommodationSupportGuard]
  },
  {
    path: "reqConfirmation",
    component: ConfirmationComponent,
    canActivate: [AuthInternalAccommodationSupportGuard]
  },
  {
    path: "accSupportDoc",
    component: AccSupportDocumentationComponent,
    canActivate: [AuthInternalGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutesModule {}



// WEBPACK FOOTER //
// ./client/views/app.route.ts